export const private_projects = [
  {
    id: "0",
    title: "The Planets",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/planets.png",
    link: "https://hamzahfayad.github.io/planets-facts/",
    topic: ["All Projects", "HTML/SCSS/JS", "JSON"],
  },
  {
    id: "1",
    title: "p5.js projects (Generative Art)",
    img: "https://hamzahfayad.github.io/p5.js/images/firework.png",
    link: "https://hamzahfayad.github.io/p5.js/",
    topic: ["All Projects", "p5.js"],
  },
  {
    id: "2",
    title: "What-if Simulation Tool (U5MR)",
    img: "/images/u5mr.png",
    link: "https://childmortalityrate-simulation.streamlit.app/",
    topic: ["All Projects", "Machine Learning / Data"],
  },
  {
    id: "3",
    title: "Night Drift - Game",
    img: "/images/NightDrive.gif",
    link: "https://mizo99.itch.io/night-drift",
    topic: ["All Projects", "p5.js"],
  },
  {
    id: "4",
    title: "retro-style Song Box v1.2 (in progress)",
    img: "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
    link: "https://song-box.netlify.app/",
    topic: ["All Projects", "React"],
  },
  {
    id: "5",
    title: "Endless Train Ride",
    img: "/images/train.png",
    link: "https://hamzahfayad.github.io/p5.js/p5_selfportrait/",
    topic: ["All Projects", "p5.js"],
  },
  {
    id: "6",
    title: "Fish and Prey",
    img: "/images/fish.png",
    link: "https://hamzahfayad.github.io/p5.js/p5_fish/",
    topic: ["All Projects", "p5.js"],
  },
  {
    id: "7",
    title: "Github Users",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/devfinder.jpg",
    link: "https://hamzahfayad.github.io/devfinder/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  {
    id: "8",
    title: "Global CoffeeStats",
    img: "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
    link: "https://github.com/HamzahFayad/coffee-analysis",
    topic: ["All Projects", "Machine Learning / Data"],
  },
  {
    id: "9",
    title: "Sales Data Analysis",
    img: "https://raw.githubusercontent.com/HamzahFayad/sales-analysis/main/SalesAnalysis/plots/output1.png",
    link: "https://github.com/HamzahFayad/sales-analysis",
    topic: ["All Projects", "Machine Learning / Data"],
  },
  {
    id: "10",
    title: "Netflix Data Exploration",
    img: "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
    link: "https://github.com/HamzahFayad/netflix-insights",
    topic: ["All Projects", "Machine Learning / Data"],
  },
  {
    id: "11",
    title: "Weather App",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/weather-app.png",
    link: "https://hamzahfayad.github.io/weather-app/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  {
    id: "12",
    title: "Todo",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/todo.png",
    link: "https://hamzahfayad.github.io/todo/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  {
    id: "13",
    title: "musAic - shuffle sounds",
    img: "/images/musaic.png",
    link: "https://musaic-shuffle.netlify.app/",
    topic: ["All Projects", "React"],
  },
  {
    id: "14",
    title: "Studio Ghibli",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/studioghibli.JPG",
    link: "https://hamzahfayad.github.io/studioghibli/",
    topic: ["All Projects", "HTML/SCSS/JS"],
  },
  {
    id: "15",
    title: "glow communication homepage",
    img: "/images/glow.png",
    link: "https://glow-berlin.de/",
    topic: ["All Projects", "Wordpress"],
  },
  {
    id: "16",
    title: "Social Media Dashboard",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/social-media-dashboard.jpg",
    link: "https://hamzahfayad.github.io/social-media-dashboard/",
    topic: ["All Projects", "HTML/SCSS/JS"],
  },
];
